// ControlOrderDetails.js
import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useControlAuth } from '../../ControlAuthContext';
import './ControlOrderDetails.css';

const ControlOrderDetails = () => {
  const { orderNumber } = useParams();
  const { user } = useControlAuth();
  const [order, setOrder] = useState(null);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrderDetails = async () => {
      setLoading(true);
      setError(null);
      const token = localStorage.getItem('controlToken');
      try {
        const response = await axios.get(`https://valleyapi-dr9y.onrender.com/api/control/orders/${orderNumber}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        setOrder(response.data.order);
        setItems(response.data.items);
      } catch (err) {
        if (err.response?.status === 403) {
          navigate('/control');
        } else {
          setError('Failed to fetch order details');
        }
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    if (user) {
      fetchOrderDetails();
    }
  }, [user, orderNumber, navigate]);

  const handleDelete = async () => {
    if (window.confirm('Are you sure you want to delete this order? This action cannot be undone.')) {
      const token = localStorage.getItem('controlToken');
      try {
        await axios.post(`https://valleyapi-dr9y.onrender.com/api/control/orders/delete`, 
          { order_numbers: [order.id] }, 
          { headers: { Authorization: `Bearer ${token}` } }
        );
        navigate('/control/orders-control');
      } catch (err) {
        setError('Failed to delete order');
        console.error(err);
      }
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;
  if (!order) return <div>Order not found</div>;

  const canEditOrDelete = user.accesstype === 0 || order.userid === user.userid;

  return (
    <div className="cod-container">
      <h2>Order Details - #{order.orderid}</h2>
      <Link to="/control/orders-control" className="cod-back">Back to Orders</Link>
      
      <div className="cod-info">
        <p><strong>Order ID:</strong> {order.orderid}</p>
        <p><strong>Owner:</strong> {order.userid}</p>
        <p><strong>Client ID:</strong> {order.idclient}</p>
        <p><strong>Creation Date:</strong> {new Date(order.date).toLocaleDateString()}</p>
        <p><strong>Week:</strong> {order.week}</p>
        <p><strong>Trimester:</strong> {order.trimester}</p>
        <p><strong>Status:</strong> {order.status}</p>
        <p><strong>Description:</strong> {order.description}</p>
        <p><strong>Comments:</strong> {order.comments}</p>
        <p><strong>Delivery Date:</strong> {order.delivery_date ? new Date(order.delivery_date).toLocaleDateString() : 'N/A'}</p>
        <p><strong>Margins:</strong> {order.margins}</p>
        <p><strong>Commission:</strong> {order.commission}</p>
      </div>

      {canEditOrDelete && (
        <>
        <Link to={`/control/orders-control/edit/${order.id}`} className="cod-back">Edit Order</Link>

          <button className="cod-delete" onClick={handleDelete}>
            Delete Order
          </button>
        </>
      )}

      <h3>Order Items</h3>
      <table className="cod-table">
        <thead>
          <tr>
            <th>Product</th>
            <th>Brand</th>
            <th>Description</th>
            <th>Cost</th>
            <th>Price</th>
            <th>Quantity</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody>
          {items.map(item => (
            <tr key={item.id}>
              <td>{item.product}</td>
              <td>{item.brand}</td>
              <td>{item.description}</td>
              <td>${item.cost}</td>
              <td>${item.price}</td>
              <td>{item.quantity}</td>
              <td>${(item.price * item.quantity).toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {items.length === 0 && <p>No items found for this order.</p>}
    </div>
  );
};

export default ControlOrderDetails;